<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    // localStorage.clear()
    const { token, userName, companyId } = this.$route.query;
    if (token && userName) {
      localStorage.setItem("token", token);
      localStorage.setItem("userName", userName);
      localStorage.setItem("companyId", companyId);
      this.$router.replace("/home");
    }
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body {
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
}
</style>
